<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2 ml">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>از تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.from_statistics_date.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.from_statistics_date.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تا تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.to_statistics_date.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.to_statistics_date.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_final.val"
                                        :description="form.is_final.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: 'true', label:'نهایی شده'},
                                            {value: 'false', label: 'نهایی نشده'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_final.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="count_type"
                                        :description="count_type.inv"
                                        label="نوع تعداد"
                                        :options="[
                                            {value: '1', label:'تعداد صفحه'},
                                            {value: '2', label: 'تعداد پیام'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="count_type=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get_all();get();setQueryStrings()" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" class="ml" color="danger">حذف فیلتر</CButton>
                                <CButton @click="download_modal=true" color="info">دانلود آمار ارسال با فرمت JSON</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
                <CButton v-show="$store.state.perms.can_recalculate_statistics_messages"
                    @click="collapse_1=!collapse_1" color="primary" class="mb-2">
                    محاسبه آمار
                </CButton>
                <CCollapse :show="collapse_1" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های محاسبه آمار</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>از تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="calc.from_time.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{calc.from_time.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تا تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="calc.to_time.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{calc.to_time.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="recalculate()" color="primary">ثبت</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>مجموع</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable hover striped :items="all_items" :fields="all_fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #undelivered_returned_fee_for_undelivery_base_line="data">
                                <td v-if="$store.state.perms.view_all_users_statistics">
                                    {{data.item.undelivered_returned_fee_for_undelivery_base_line}}
                                </td>
                                <td v-else>---</td>
                            </template>
                            <template #action="">
                                <td>
                                    <template>
                                        <div class="flex-container">
                                            <div @click="open_to(`/messages/statistics/0/operators/all/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                v-c-tooltip.hover="'اپراتور‌ها'">
                                                <CIcon name="cilListRich" size="lg"/>
                                            </div>
                                            <div @click="open_to(`/messages/statistics/0/numbers/all/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                v-c-tooltip.hover="'شماره‌ها'">
                                                <CIcon name="cilListRich" size="lg"/>
                                            </div>
                                            <div @click="open_to(`/messages/statistics/0/gateways/operators/all/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                v-c-tooltip.hover="'درگاه‌ها به تفکیک اپراتور'">
                                                <CIcon name="cilListRich" size="lg"/>
                                            </div>
                                            <div @click="open_to(`/messages/statistics/0/gateways/all/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                v-c-tooltip.hover="'درگاه‌ها'">
                                                <CIcon name="cilListRich" size="lg"/>
                                            </div>
                                        </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>آمار ارسال</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #is_final="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_final)">
                                        {{data.item.is_final}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #undelivered_returned_fee_for_undelivery_base_line="data">
                                <td v-if="$store.state.perms.view_all_users_statistics">
                                    {{data.item.undelivered_returned_fee_for_undelivery_base_line}}
                                </td>
                                <td v-else>---</td>
                            </template>
                            <template #action="data">
                                <td>
                                    <template>
                                        <div class="flex-container">
                                                <div @click="open_to(`/messages/statistics/${data.item.id}/operators/single/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                    v-c-tooltip.hover="'اپراتور‌ها'">
                                                    <CIcon name="cilListRich" size="lg"/>
                                                </div>
                                                <div @click="open_to(`/messages/statistics/${data.item.id}/numbers/single/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                    v-c-tooltip.hover="'شماره‌ها'">
                                                    <CIcon name="cilListRich" size="lg"/>
                                                </div>
                                                <div @click="open_to(`/messages/statistics/${data.item.id}/gateways/operators/single/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                    v-c-tooltip.hover="'درگاه‌ها به تفکیک اپراتور'">
                                                    <CIcon name="cilListRich" size="lg"/>
                                                </div>
                                                <div @click="open_to(`/messages/statistics/${data.item.id}/gateways/single/${count_type}/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                    v-c-tooltip.hover="'درگاه‌ها'">
                                                    <CIcon name="cilListRich" size="lg"/>
                                                </div>
                                                <div @click="open_to(`/messages/statistics/${data.item.id}/details/${qs.user}/${qs.from}/${qs.to}/${qs.state}`)"
                                                    v-c-tooltip.hover="'جزییات'">
                                                    <CIcon name="cilListRich" size="lg"/>
                                                </div>
                                        </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="download_modal"
            >
            <p>آیا برای دانلود آمار ارسال با فرمت JSON اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="download_modal=false" color="secondary">خیر</CButton>
            <CButton @click="validator();download()" color="primary">بله</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'date', label: 'تاریخ' },
                { key: 'all_messages_count', label: 'تعداد پیام‌ها' },
                { key: 'all_messages_sms_fee', label: 'هزینه پیام‌ها' },
                { key: 'blocked_messages_count', label: 'تعداد لیست سیاه' },
                { key: 'blocked_messages_sms_fee', label: 'هزینه لیست سیاه' },
                { key: 'delivered_messages_count', label: 'تحویل داده شده' },
                { key: 'delivered_messages_sms_fee', label: 'هزینه پیام ارسالی (delivered)' },
                { key: 'error_messages_count', label: 'تعداد خطا' },
                { key: 'error_messages_sms_fee', label: 'هزینه خطا' },
                { key: 'reject_messages_count', label: 'رد شده' },
                { key: 'reject_messages_sms_fee', label: 'هزینه رد شده' },
                { key: 'returned_fee', label: 'هزینه بازگشتی (خطا)' },
                { key: 'timeout_messages_count', label: 'رسیده به مخابرات' },
                { key: 'timeout_messages_sms_fee', label: 'هزینه رسیده به مخابرات' },
                { key: 'undelivered_messages_count', label: 'تحویل داده نشده' },
                { key: 'undelivered_messages_sms_fee', label: 'هزینه تحویل داه نشده' },
                { key: 'undelivered_returned_fee_for_delivery_base_line', label: 'هزینه بازگشتی (delivery base)' },
                { key: 'undelivered_returned_fee_for_undelivery_base_line', label: '---' },
                { key: 'unknown_messages_count', label: 'تعداد نامشخص' },
                { key: 'unknown_messages_sms_fee', label: 'هزینه نامشخص' },
                { key: 'is_final', label: 'وضعیت' },
                { key: 'action', label: 'عملیات' },
            ],
            all_fields: [
                { key: 'all_messages_count', label: 'تعداد پیام‌ها' },
                { key: 'all_messages_sms_fee', label: 'هزینه پیام‌ها' },
                { key: 'blocked_messages_count', label: 'تعداد لیست سیاه' },
                { key: 'blocked_messages_sms_fee', label: 'هزینه لیست سیاه' },
                { key: 'delivered_messages_count', label: 'تحویل داده شده' },
                { key: 'delivered_messages_sms_fee', label: 'هزینه پیام ارسالی (delivered)' },
                { key: 'error_messages_count', label: 'تعداد خطا' },
                { key: 'error_messages_sms_fee', label: 'هزینه خطا' },
                { key: 'reject_messages_count', label: 'رد شده' },
                { key: 'reject_messages_sms_fee', label: 'هزینه رد شده' },
                { key: 'returned_fee', label: 'هزینه بازگشتی (خطا)' },
                { key: 'timeout_messages_count', label: 'رسیده به مخابرات' },
                { key: 'timeout_messages_sms_fee', label: 'هزینه رسیده به مخابرات' },
                { key: 'undelivered_messages_count', label: 'تحویل داده نشده' },
                { key: 'undelivered_messages_sms_fee', label: 'هزینه تحویل داه نشده' },
                { key: 'undelivered_returned_fee_for_delivery_base_line', label: 'هزینه بازگشتی (delivery base)' },
                { key: 'undelivered_returned_fee_for_undelivery_base_line', label: '---' },
                { key: 'unknown_messages_count', label: 'تعداد نامشخص' },
                { key: 'unknown_messages_sms_fee', label: 'هزینه نامشخص' },
                { key: 'action', label: 'عملیات' },
            ],
            collapse: false,
            collapse_1: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                from_statistics_date: { val: '', inv: '', v: { max: 16 } },
                to_statistics_date: { val: '', inv: '', v: { max: 16 } },
                is_final: { val: '', inv: '', v: { max: 5 } },
            },
            count_type: '1',
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            users: [],
            all_items: [],
            download_modal: false,
            qs:{
                user: 0,
                from: 0,
                to: 0,
                state: 0,
            },
            calc: {
                from_time: { val: '', inv: '', v: { max: 16 } },
                to_time: { val: '', inv: '', v: { max: 16 } },
            }
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get_all();
        this.get();
        this.get_users();
    },
    methods: {
        get_users(){
            this.axios.get('users/?type=view_statistics')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge(status) {
            switch(status) {
                case 'نهایی نشده': return 'danger';
                case 'نهایی شده': return 'success';
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'from_statistics_date' || key == 'to_statistics_date') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else{
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('user_statistics/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('user_statistics/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&user_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                if(val.is_final){
                                    val.is_final = 'نهایی شده';
                                } else{
                                    val.is_final = 'نهایی نشده';
                                }
                                val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
                                val.date = this.$moment(val.user_statistics.day, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD');
                                for(const key in val.user_statistics.messages_infos){
                                    if(key == 'undelivered_returned_fee_for_delivery_base_line'
                                        || key == 'undelivered_returned_fee_for_undelivery_base_line'
                                        || key == 'returned_fee'){
                                            val[key] = String(val.user_statistics.messages_infos[key]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    } else {
                                        if(this.count_type == '1'){
                                            val[`${key}_count`] = String(val.user_statistics.messages_infos[key].page_count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        } else if(this.count_type == '2') {
                                            val[`${key}_count`] = String(val.user_statistics.messages_infos[key].count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        val[`${key}_sms_fee`] = String(val.user_statistics.messages_infos[key].sms_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                }
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        get_all(){
            let filter = '';
            if(this.filter){
                for (const key in this.form) {
                    if(this.form[key].val != ''){
                        if (key == 'from_statistics_date' || key == 'to_statistics_date') {
                            filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                        } else if(key != 'is_final'){
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
            }
            this.axios.get('user_statistics/' 
                + '?all_statistics=1' 
                + filter)
                .then(res => {
                    for(const key in res.data.messages_infos){
                        if(key == 'undelivered_returned_fee_for_delivery_base_line'
                            || key == 'undelivered_returned_fee_for_undelivery_base_line'
                            || key == 'returned_fee'){
                                res.data[key] = String(res.data.messages_infos[key]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            if(this.count_type == '1'){
                                res.data[`${key}_count`] = String(res.data.messages_infos[key].page_count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            } else if(this.count_type == '2') {
                                res.data[`${key}_count`] = String(res.data.messages_infos[key].count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                            res.data[`${key}_sms_fee`] = String(res.data.messages_infos[key].sms_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                    this.all_items = [res.data];
                })
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get_all();
            this.get();
            this.qs.user =  this.qs.from = this.qs.to = this.qs.state = 0;
        },
        download(){
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'فایل در حال دانلود است. لطفا صبور باشید.'
            });
            this.download_modal = false;
            if(this.disable == false){
                let filter = '';
                for (const key in this.form) {
                    if(this.form[key].val != ''){
                        if (key == 'statistics_date') {
                            filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                        } else{
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('user_statistics/' 
                    + '?user_info=1' 
                    + filter)
                    .then(res => {
                        let FileSaver = require('file-saver');
                        let blob = new Blob([JSON.stringify(res.data, null, '\t')], {type: "text/plain;charset=utf-8"});
                        FileSaver.saveAs(blob, 'data.json');
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
		open_to(route) {
            window.open(`/#${route}`, '_blank').focus()
        },
        setQueryStrings(){
            this.qs.user =  this.qs.from = this.qs.to = this.qs.state = 0;
            this.form.user_id.val != '' ? this.qs.user = this.form.user_id.val : {};
            this.form.from_statistics_date.val != '' ? this.qs.from = this.$moment(this.form.from_statistics_date.val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD') : {};
            this.form.to_statistics_date.val != '' ? this.qs.to = this.$moment(this.form.to_statistics_date.val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD') : {};
            this.form.is_final.val != '' ? this.qs.state = this.form.is_final.val : {};
        },
        recalculate(){
            if(this.$store.state.perms.can_recalculate_statistics_messages == true){
                this.axios.get('user_statistics/' 
                + '?from_time=' + this.calc.from_time.val 
                + '&to_time=' + this.calc.to_time.val )
                .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'درخواست شما با موفقیت ثبت شد. محاسبه آمار در پس زمینه انجام خواهد شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            } else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    text: 'خطا! به محاسبه آمار دسترسی ندارید.'
                });
            }
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.view_user_info_statistics == false
            && this.$store.state.perms.view_all_users_statistics == false
            && this.$store.state.perms.view_same_group_users_statistics == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
